module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraBold.004ce174.ttf";